export const REPEAT_EVERY_QUANTITY_OPTIONS = [
  { value: 1, label: 'every' },
  { value: 2, label: 'every 2' },
  { value: 3, label: 'every 3' },
  { value: 4, label: 'every 4' },
  { value: 5, label: 'every 5' },
  { value: 6, label: 'every 6' },
  { value: 7, label: 'every 7' },
  { value: 8, label: 'every 8' },
  { value: 9, label: 'every 9' },
  { value: 10, label: 'every 10' },
  { value: 11, label: 'every 11' },
];

export const REPEAT_EVERY_PERIOD_OPTIONS = [
  { value: 'daily', label: 'Days' },
  { value: 'weekly', label: 'Weeks' },
  { value: 'monthly', label: 'Months' },
  { value: 'yearly', label: 'Years' },
];

export const ARCHIVE_EVERY_QUANTITY_OPTIONS = [
  { value: 1, label: 'every' },
  { value: 2, label: 'every 2' },
  { value: 3, label: 'every 3' },
  { value: 4, label: 'every 4' },
  { value: 5, label: 'every 5' },
  { value: 6, label: 'every 6' },
  { value: 7, label: 'every 7' },
  { value: 8, label: 'every 8' },
  { value: 9, label: 'every 9' },
  { value: 10, label: 'every 10' },
  { value: 11, label: 'every 11' },
];

export const ARCHIVE_EVERY_PERIOD_OPTIONS = [
  { value: 'daily', label: 'Days' },
  { value: 'weekly', label: 'Weeks' },
  { value: 'monthly', label: 'Months' },
  { value: 'yearly', label: 'Years' },
];
